// Full-page navigation behind one seam. jsdom 26 (Jest 30) makes window.location and
// location.assign non-configurable, so tests cannot stub them; they mock this module instead.
export const navigateTo = (url) => {
  window.location.assign(url)
}
